import React from "react";
import { Beef, Flame, Leaf } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheArtBehindTheSmoke() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const steps = [{
    icon: Beef,
    title: "הבשר",
    description: "אנו בוחרים בקפידה נתחי בקר מובחרים, תוך דגש על איכות, טריות ושיש מושלם המבטיח עסיסיות בכל ביס."
  }, {
    icon: Leaf,
    title: "התיבול",
    description: "תערובת התבלינים הסודית שלנו מורכבת מרכיבים טבעיים בלבד. שילוב מדויק של טעמים וארומות שנועד להעצים את טעמו הטבעי של הבשר."
  }, {
    icon: Flame,
    title: "העישון",
    description: "תהליך עישון איטי ומסורתי. הזמן והסבלנות הם המרכיב הסודי שמעניק לבשר את המרקם הנימוח והטעם המעושן העמוק."
  }];
  return <section id="האומנות-שמאחורי-העשן" className="dark bg-background text-foreground py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
      
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-secondary/5 blur-[120px] rounded-full pointer-events-none" />

      <div ref={ref} className={cn("container mx-auto px-6 relative z-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-24">
          {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center group">
              {}
              <div className="mb-8 relative">
                <div className="absolute inset-0 bg-secondary/10 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <step.icon strokeWidth={1.5} className="w-20 h-20 text-[hsl(28_40%_55%)] transition-transform duration-500 group-hover:scale-110" aria-hidden="true" />
              </div>

              {}
              <h3 className="text-3xl font-bold text-primary mb-6 tracking-wide">
                {step.title}
              </h3>

              {}
              <p className="text-muted-foreground text-lg leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}